<template>
  <div>
    <div id="alertsModal" class="modal right fade registrationComponent" role="dialog">
      <div class="modal-dialog modal-lg">
        <!-- <loader :loadingStatus="loaderStatus || initialLoader"></loader> -->
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="alerts-header">
<p class="alert-title">{{$t('alerts')}}</p>
            <img
            src="/static/images/icons/alerts_notification_close_icon.svg"
            class="close-icon"
            data-dismiss="modal"
          />
            </div>
          </div>
          <div
            class="modal-body mx-ht">
            <div class="row" v-for="(alert, index) in alertsList" :key="index">
              <div class="col-md-12 padding-reset">
                <div class="d-flex align-items-center">
                    <div class="col-md-12" :class="index !== 0 ? 'alert-content-description' : ''">
                        <!-- <p class="alert-name">{{alert.message}}</p> -->
                        <p class="alert-description">{{alert.message}}</p>
                    </div>
                    <!-- <div class="col-md-1 end">
                        <img src="/static/images/icons/alerts_notification_close_icon.svg" />
                    </div> -->
                </div>
              </div>
              <div v-if="index !== (alertsList.length - 1)" class="col-md-12">
                <hr class="header-line">
              </div>
            </div>
            <div class="no-alerts" v-if="alertsList.length === 0">{{$t('noAlerts')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { getAlerts } from '../../apis/profile';
import { deleteAndAddToChecklist } from '../../apis/regulationCheck';

export default {
  props: {
    alertsList: Array,
  },
  data() {
    return {
    };
  },
  mounted() {
    $('#alertsModal').on('shown.bs.modal', () => {
      $('html').css('overflow', 'hidden');
    }).on('hidden.bs.modal', () => {
      $('html').css('overflow', 'auto');
    });
  },
  methods: {
    async addToChecklist(id) {
      await deleteAndAddToChecklist(id);
      if (this.$route.path.contains('todo-list')) {
        this.$router.go();
      }
      const result = await getAlerts();
      this.alertsList = result.data;
    },
  },
};
</script>

<style scoped>
.padding-reset {
  padding: 2px 15px;
}
.mt--2 {
  margin-top: -2px;
}
.mx-ht {
  max-height: calc(100% - 80px) !important;
}
.header-line {
  margin: 0px 11px;
  border-top: 0.7px solid #D3D3D3;
}
.end {
    display: flex;
    justify-content: flex-end;
}
.add-to-checklist-wrapper {
    display: flex;
    justify-content: flex-end;
    height: 88px;
    align-items: center;
    padding-right: 0px;
}
.alert-content-description {
    /* padding: 12px 15px 2px; */
}
.add-to-checklist {
    color: #01518A;
    font-size: 14px;
    line-height: 19px;
    margin-left: 5px;
}
.alert-name {
    color: #000001;
    font-weight: 600;
    margin-bottom: 5px;
}
.alert-description {
    color: #3E3E3E;
    margin-top: 12px;
    margin-bottom: 12px;
}
.modal-content {
    overflow-y: unset !important;
    border-radius: 0px;
}
.modal-dialog {
    width: 58% !important;
}
.modal-header {
    background-color: #ffffff;
    border-bottom: none;
    padding-bottom: 0px;
}
.alerts-header {
    display: flex;
    border-bottom: 0.7px solid #D3D3D3;
}
.close-icon {
    position: absolute;
    right: 16px;
    padding-top: 5px;
    cursor: pointer;
}
.alert-title {
    margin: 0;
    font-size: 24px;
    font-weight: 300;
    line-height: 33px;
    color: #000000;
    padding-bottom: 16px;
    padding-left: 10px;
}
.modal-body {
    overflow-x: hidden;
    padding: 0px 10px 10px !important;
}
.modal.right .modal-body {
    padding-bottom: 0px !important;
}
.no-alerts {
  text-align: center;
  margin-top: 20px;
}
</style>
